import React from 'react';
import { connect } from 'react-redux';
import { useTranslate } from '../../../core/translate';
import Modal, {
  ModalBody,
  ModalFooter,
  ModalFooterButtons,
  ModalFooterCustomButton,
} from '../../components/modal/Modal';

const ThirdPartyModal = ({ onClose, url, brand, country }) => {
  const translate = useTranslate();

  country = country.toLowerCase();
  const site = `${brand}.${country}`;

  const header = translate('third.pary.site.disclosure.header.v3', {
    site,
  });
  const body = translate('third.pary.site.disclosure.v3', {
    site,
  });

  const cancelButtonLabel = translate('byo.page.general.cancel');
  const continueButtonLabel = translate('byo.page.general.continue');

  const onContinueClick = () => {
    window.open(url, '_blank');
    onClose();
  };

  return (
    <>
      {url ? (
        <Modal
          isOpen={true}
          fullscreen={false}
          className="third-party-disclosure__modal"
          overlayClassName="third-party-disclosure__modal-overlay"
          contentLabel={header}
          onRequestClose={onClose}>
          <ModalBody innerClassName="third-party-disclosure__modal-body__inner">
            <h1
              className="third-party-disclosure__header"
              dangerouslySetInnerHTML={{ __html: header }}
            />
            <p
              className="third-party-disclosure__body"
              dangerouslySetInnerHTML={{ __html: body }}
            />
          </ModalBody>
          <ModalFooter className="third-party-disclosure__footer">
            <ModalFooterButtons>
              <ModalFooterCustomButton
                className="third-party-disclosure__footer-button--cancel stat-button-link"
                onSelect={onClose}
                data-dtm={header}>
                {cancelButtonLabel}
              </ModalFooterCustomButton>
              <ModalFooterCustomButton
                className="third-party-disclosure__footer-button stat-button-link"
                onSelect={onContinueClick}
                data-dtm={header}>
                {continueButtonLabel}
              </ModalFooterCustomButton>
            </ModalFooterButtons>
          </ModalFooter>
        </Modal>
      ) : null}
    </>
  );
};

const mapStateToProps = (state) => {
  const { assetsBrand: brand, country } = state.appResources;
  return {
    brand,
    country,
  };
};

export default connect(mapStateToProps)(ThirdPartyModal);
